import React, { useEffect } from "react";
import { CheckCircle, XCircle } from "lucide-react";

export default function SettingsAmazonDone() {
  const params = new URLSearchParams(window.location.search);
  const status = params.get("status");
  const code = params.get("code");

  useEffect(() => {
    if (!window.opener) return;

    if (status === "success") {
      window.opener.postMessage({ status: "success" }, window.location.origin);
    } else {
      window.opener.postMessage(
        { status: "error", code: code ?? "UNKNOWN" },
        window.location.origin,
      );
    }

    window.close();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Fallback if window.opener is gone (direct navigation)
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
      <div className="text-center space-y-3">
        {status === "success" ? (
          <CheckCircle className="w-12 h-12 text-emerald-500 mx-auto" />
        ) : (
          <XCircle className="w-12 h-12 text-rose-500 mx-auto" />
        )}
        <p className="text-sm text-slate-600 dark:text-slate-400">
          {status === "success"
            ? "Amazon authorization successful. You can close this window."
            : `Authorization failed${code ? ` (${code})` : ""}. You can close this window.`}
        </p>
      </div>
    </div>
  );
}
